<style lang="less">
  .comm_breadcrumb_bar {
     padding:2px 16px 0 0; box-sizing: border-box; margin-bottom: 16px;
    .el-button  {vertical-align: middle; color:#333; padding:0;}
    .el-breadcrumb { padding-left:8px; margin-left:8px;
      .el-breadcrumb__inner {color:#666;}
      .el-breadcrumb__separator {color:#666;}

      .el-breadcrumb__item:last-child .el-breadcrumb__inner,
      .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{color:#4183fc;}
    }
  }
</style>
<template>
  <div class="comm_breadcrumb_bar" v-if="false">
    <slot name="buttons"><el-button type="text" size="small" icon="el-icon-arrow-left">返回</el-button></slot>
    <!-- <slot name="buttons"></slot> -->
    <slot></slot>
  </div> 
</template>
<script>
export default {
  name: 'comm_breadcrumb_bar',
  props: {
    buttons: {
      type: String,
    },
  },
  data: function() {
    return {
    }
  },

  created() {},

  mounted() {
    this.$nextTick(function() {

    })
  },

  methods: {
    goback(){
      this.$router.back(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/commonplugin/common/comm_breadcrumb_bar.vue